import {Component, Injector} from '@angular/core';
import {IManagableObject} from "../../IManagableObject";
import {Observable} from "rxjs";
import {GroupBaseAdminPanelComponent} from "../../base-admin-panel/group-base-admin-panel.component";
import {EditDriverComponent} from "../edit-driver.component";
import {CreateDriverComponent} from "../create-driver.component";
import {DriversService} from "../../../../services/drivers.service";
import { DriversViewModel } from "../models/DriversViewModel";
import { PenaltyDialogComponent } from "../penalty-dialog/penalty-dialog.component";
import {ObjectImportResult} from "../../../../models/ObjectImportResult";
import {DriverImportResultModel} from "../../../../models/DriverImportResultModel";


@Component({
    selector: '[app-drivers]',
    templateUrl: './drivers.component.html',
    styleUrls: ['./drivers.component.css'],
    standalone: false
})
export class AdminDriversComponent extends GroupBaseAdminPanelComponent {

  constructor(private service: DriversService, protected injector: Injector) {
    super(injector);
    this.groupName = "DriversGroup";
    this.entityName = "Driver";
  }

  protected Refresh() {
    this.service.GetAllDrivers().subscribe(drivers => {
      this.objects = drivers;
    });

    this.service.GetGroups().subscribe(groups => {
      this.groupFilter.groups = groups;
    });
  }

  public openEditModal(driver: DriversViewModel) {
    this.prepareModal(EditDriverComponent);
    this.componentRef.instance.open(driver);
  }

  public openCreateModal() {
    this.prepareModal(CreateDriverComponent);
    this.componentRef.instance.open(new DriversViewModel());
  }

  public openPenaltyModal() {
    this.service.GetPenalty().subscribe(driver => {
      this.prepareModal(PenaltyDialogComponent);
      this.componentRef.instance.open(driver);
    });
  }

  protected doCreateGroup(input: IManagableObject): Observable<any> {
    return this.service.CreateGroup(input);
  }

  protected doDeleteGroup(input: IManagableObject): Observable<any> {
    return this.service.DeleteGroup(input);
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.service.DeleteObject(id);
  }

  importDrivers(event) {
    let file = event.target.files[0];
    const importFailedMsg = this.translate.instant("Import failed");
    const importSuccessMsg = this.translate.instant("Imported");
    const keysConflictMsg = this.translate.instant("Key duplicates");

    if (file) {
      this.service.importFromFile(file)
        .subscribe({
          next: (response: DriverImportResultModel) => {
            this.toastr.success(`${importSuccessMsg}: ${response.SuccessDriversCount}`);
            if (response.DriverKeyUidDuplicates.length > 0)
              this.toastr.error(`${keysConflictMsg}: ${response.DriverKeyUidDuplicates.length}`);
            if (response.DriverNameDuplicates.length > 0)
              this.toastr.error(`${importFailedMsg}: ${response.DriverNameDuplicates.length}`);
            this.Refresh();
          },
          error: () => {
            this.toastr.error(importFailedMsg);
          }
        });
    }
  }
}
